module.exports = __webpack_public_path__ + "static/media/NoAssociationsCreatedIcon.d3dd9382.svg";